module.exports = __webpack_public_path__ + "static/media/Athulraj k.06fd567d.jpg";